import { blackOrange, textMuted } from '@/theme/colors'
import styled from 'styled-components'
import { text, leading } from '@/theme/typography'

export const Centered = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 32px;
	text-align: center;
`

export const SpinnerWrap = styled.div`
	margin-bottom: 20px;
`

export const StateTitle = styled.h1`
	${text.heading}
	color: ${blackOrange};
	margin: 16px 0 10px;
`

export const StateMessage = styled.p`
	${text.bodySm}
	color: ${textMuted};
	margin: 0;
	max-width: 380px;
	line-height: ${leading.body};
`

/** The optional way out under the message — a link back to the app for someone with somewhere to go. */
export const StateActions = styled.div`
	margin-top: 28px;
	display: flex;
	justify-content: center;
`
